import BaseTermDelegate from './base';

export default class LayoutTermDelegate extends BaseTermDelegate {
  get boundOutputs() {
    return this.term.terms.map((t) => t.delegate.boundOutputs).flat();
  }
}
